module.exports = __webpack_public_path__ + "0d86a69e9c331dfe992404e5ba35ef40.png";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/tempo.png
// module id = 415
// module chunks = 0